import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { APP_LANGUAGE_STORAGE_KEY, normalizeAppLanguage } from '../utils/appLanguage';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en';

  try {
    const storedLanguage = window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
    if (storedLanguage) {
      return normalizeAppLanguage(storedLanguage);
    }
  } catch (error) {
    // Ignore storage access failures and fall back gracefully.
  }

  const browserLanguage = window.navigator?.language?.slice(0, 2);
  return normalizeAppLanguage(browserLanguage);
};

i18n
  // i18next-http-backend ကို ချိတ်ဆက်ခြင်း
  // ၎င်းသည် public/locales မှ ဘာသာပြန်ဖိုင်များကို ဆွဲယူပေးပါမည်။
  .use(HttpBackend)
  
  // i18n instance ကို react-i18next သို့ ပေးအပ်ခြင်း
  .use(initReactI18next)
  
  // i18n ကို စတင် configure လုပ်ခြင်း
  .init({
    lng: getInitialLanguage(),
    supportedLngs: ['en', 'mm'],

    // 1. Performance & Scalability
    // backend options:
    backend: {
      // ဘာသာပြန်ဖိုင်များ၏ "Source" path ကို သတ်မှတ်ခြင်း
      // CEO Vision (Scalability): ဤနေရာတွင် '/locales/{{lng}}/{{ns}}.json' ဟု
      // သတ်မှတ်ထားခြင်းကြောင့် 'jp' ကဲ့သို့ ဘာသာစကားအသစ်များ ထပ်တိုးသည့်အခါ
      // ဤ code ကို ပြန်ပြင်စရာမလိုဘဲ public/locales/jp/ folder ကိုသာ
      // ထည့်သွင်းလိုက်ရုံဖြင့် အလုပ်လုပ်ပါမည်။
      loadPath: '/locales/{{lng}}/translation.json',
    },

    // 2. Stability (Error Handling)
    // အကယ်၍ user က 'mm' ကို ရွေးချယ်သော်လည်း 'mm' တွင် 
    // ဘာသာပြန်မရှိသေးသော key တစ်ခုကို ခေါ်မိပါက၊ 
    // app crash မဖြစ်စေဘဲ 'en' မှ စာသားကို အလိုအလျောက် ပြသပေးပါမည်။
    fallbackLng: 'en',

    // 3. Debugging (Development Mode တွင်သာ အသုံးပြုရန်)
    // console တွင် i18n ၏ loading status များကို ပြသပေးမည်။
    // production build တွင် ပိတ်ထားပါမည်။
    debug: process.env.NODE_ENV === 'development',
    load: 'currentOnly',

    // react-i18next အတွက် options
    interpolation: {
      // React သည် XSS attacks များကို default ကာကွယ်ပေးပြီးဖြစ်သောကြောင့်
      // ဤ option ကို false ထားခြင်းက ပိုမိုသင့်လျော်ပါသည်။
      escapeValue: false, 
    },

    // 4. Maintainability
    // 'translation' namespace ကိုသာ default အသုံးပြုမည်။
    // ၎င်းသည် public/locales/en/translation.json ကို တိုက်ရိုက် ရည်ညွှန်းပါသည်။
    ns: ['translation'],
    defaultNS: 'translation',
    react: {
      useSuspense: true,
    },
  });

export default i18n;
